/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let memberUserListApiUrl = root.memberUserListApiUrl.link;
let memberSearchApiUrl = root.memberSearchApiUrl.link;
let connectionReqApiUrl = root.connectionReqApiUrl.link;


export default {
  state: {
    getMemberUserListState:{},
    getConnectionReqListState:{}
  },
  mutations: {
    getMemberUserListMutation(state, value) {
      Vue.set(state, 'getMemberUserListState', value);
    },
    getConnectionReqListMuatation(state, value) {
      Vue.set(state, 'getConnectionReqListState', value);
    }
  },
  actions: {
    getMemberUserListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberUserListApiUrl).then(res => {
                context.commit('getMemberUserListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    sendConnectionReqAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(connectionReqApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    getConnectionReqListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(connectionReqApiUrl).then(res => {
              context.commit('getConnectionReqListMuatation', res.data.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    searchMemberUserAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(memberSearchApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
  },
  getters: {
    getMemberUserListGetters : state => state.getMemberUserListState,
    getConnectionReqListGetters : state => state.getConnectionReqListState,
  }
}